export const TITLE = 'Zitadel';
export const COLOR_PRIMARY = '#FF2069';
